// The hero entry point for the assistant (docs/06; UX audit P1-1 — "the differentiator must
// announce itself"). A filled-teal, sparkle-marked button that reads as primary next to the
// ghost "Sign out", instead of the old grey text link. Self-contained inline styling on the
// brand tokens so it drops into the top bar without touching global CSS or the app shell —
// s6-mobile owns where it sits on mobile; this component only defines how it looks.

/** Small sparkle mark — signals "AI/assistant" without an emoji. */
function SparkIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 3l1.6 4.8L18.4 9.4 13.6 11 12 15.8 10.4 11 5.6 9.4l4.8-1.6z" />
      <path d="M18.5 15.5l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z" />
    </svg>
  );
}

export function AssistantLaunchButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      className="btn sm asst-launch"
      onClick={onClick}
      title="Open the assistant (⌘J)"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        background: 'var(--accent)',
        color: 'var(--accent-ink)',
        border: '1px solid transparent',
        fontWeight: 600,
        boxShadow: '0 0 0 1px var(--brand-accent-050), var(--shadow-sm, 0 1px 2px rgba(0,0,0,0.3))',
      }}
    >
      <SparkIcon />
      Assistant
    </button>
  );
}
